// extracted by mini-css-extract-plugin
export default {"MainDiv":"PendingOrders_MainDiv__WQkSi","TableDiv":"PendingOrders_TableDiv__R+DlA","TableButton":"PendingOrders_TableButton__CaNmY"};